import { IconMinus, IconPlus } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useContext, useRef, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { uploadImage } from '../../../../api/api.global';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';

const ProfileBlock = ({ dragButton, linkId, callback, data }) => {
    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);
    const [brandFile, setBrandFile] = useState(null);
    const brandImageUploadInputRef = useRef(null);

    function ContextAwareToggle({ eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div onClick={decoratedOnClick} className="flex items-center rounded-md bg-[#E8EDFC] gap-3 p-2 cursor-pointer">
                {dragButton}
                <p className='mb-0 text-sm font-semibold'>Profile</p>
                <div className="ms-auto"></div>
                <ToggleBtn state={data?.status == 1} onClickFunction={(e) => onBlockStatusUpdate(e)} />
                <button className='bg-white p-1.5 rounded-full' onClick={decoratedOnClick}>{isCurrentEventKey ? <IconMinus size={20} /> : <IconPlus size={20} />}</button>
            </div>
        );
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            setFile(file);
            onProfilePhotoUpdate(file);
        }
    }

    const handleBrandImageChange = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 2;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 2MB.');
            setBrandFile(null);
            e.target.value = null;
        } else {
            setBrandFile(file);
            onBrandLogoUpdate(file);
        }
    }

    async function update(postDetails) {
        let postData = {
            linkId: linkId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editBlockDataOfCard);
        loadingHide();
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const onNameUpdate = (e) => {
        let name = e.target.value;
        let postDetails = [{
            "key": "profile.name",
            "value": name
        }]

        update(postDetails);
    }

    const onHeadingUpdate = (e) => {
        let heading = e.target.value;
        let postDetails = [{
            "key": "profile.heading",
            "value": heading
        }]

        update(postDetails);
    }

    const onSubHeadingUpdate = (e) => {
        let subHeading = e.target.value;
        let postDetails = [{
            "key": "profile.subHeading",
            "value": subHeading
        }]

        update(postDetails);
    }

    const onProfilePhotoUpdate = async (image) => {
        let postDetails = [{
            "key": "profile.profilePhoto",
            "value": await uploadImage(image, 'advy-card-profile')
        }]
        update(postDetails);
    }

    const onBrandLogoUpdate = async (image) => {
        let postDetails = [{
            "key": "profile.brandLogo",
            "value": await uploadImage(image, 'advy-card-brand')
        }]
        update(postDetails);
    }

    const onBlockStatusUpdate = (e) => {
        e.stopPropagation();
        loadingShow();
        let status = data?.status == 1 ? 2 : 1;
        let postDetails = [{
            "key": "profile.status",
            "value": status
        }]
        update(postDetails);
    }

    const onProfilePhotoStatusChange = () => {
        loadingShow();
        let status = !data?.profilePhotoStatus;
        let postDetails = [{
            "key": "profile.profilePhotoStatus",
            "value": status
        }]
        update(postDetails);
    }

    const onBrandLogoStatusChange = () => {
        loadingShow();
        let status = !data?.brandLogoStatus;
        let postDetails = [{
            "key": "profile.brandLogoStatus",
            "value": status
        }]
        update(postDetails);
    }

    return (

        <div className='w-full rounded-md overflow-hidden border border-[#E8EDFC]'>
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <ContextAwareToggle eventKey={"0"} />
                    <Accordion.Body>
                        <div className="p-2">
                            <div className='flex gap-10 items-center flex-wrap'>
                                <div>
                                    <div className='flex items-center gap-2 mb-2'>
                                        <p className="font-semibold">Profile Photo</p>
                                        <ToggleBtn state={data?.profilePhotoStatus} onClickFunction={() => onProfilePhotoStatusChange()} />
                                    </div>
                                    <div className="flex gap-3">
                                        {(file || data?.profilePhoto) ? <img src={file ? URL.createObjectURL(file) : data?.profilePhoto ? data?.profilePhoto : ''} className='w-16 aspect-square rounded shadow-md object-cover' id='image-preview' alt="" /> : <div className='w-16 aspect-square rounded bg-blue-700'></div>}

                                        <input type="file" accept="image/png, image/jpeg, image/svg, image/jpg, image/webp" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                                        <button onClick={() => imageUploadInputRef.current.click()}>
                                            <img src={process.env.PUBLIC_URL + "/images/image-upload-2.png"} className='w-16 aspect-square shadow-md' alt="" />
                                        </button>
                                    </div>
                                    <p className="text-[10px] text-gray-400 mt-1 mb-2">*Maximum size: 5MB, preferred ratio is 4:5 </p>
                                </div>
                                <div>
                                    <div className='flex items-center gap-2 mb-2'>
                                        <p className="font-semibold">Company/Brand Logo</p>
                                        <ToggleBtn state={data?.brandLogoStatus} onClickFunction={() => onBrandLogoStatusChange()} />
                                    </div>
                                    <div className="flex gap-3">
                                        {(brandFile || data?.brandLogo) ? <img src={brandFile ? URL.createObjectURL(brandFile) : data?.brandLogo ? data?.brandLogo : ''} className='w-16 aspect-square rounded object-contain bg-gray-400 shadow-md' id='image-preview' alt="" /> : <div className='w-16 aspect-square rounded bg-blue-700'></div>}

                                        <input type="file" accept="image/png, image/jpeg, image/svg, image/jpg, image/webp" name="" id="" className="hidden" onChange={handleBrandImageChange} ref={brandImageUploadInputRef} />
                                        <button onClick={() => brandImageUploadInputRef.current.click()}>
                                            <img src={process.env.PUBLIC_URL + "/images/image-upload-2.png"} className='w-16 aspect-square shadow-md' alt="" />
                                        </button>
                                    </div>
                                    <p className="text-[10px] text-gray-400 mt-1 mb-2">*Maximum size: 2MB, preferred ratio is 1:1 </p>
                                </div>
                            </div>

                            <p className="text-sm font-semibold mb-1.5">Name</p>
                            <input type="text" className="form-control mb-2 w-full" placeholder="" id={'name'} defaultValue={data?.name} maxLength={255} onChange={_debounce((e) => onNameUpdate(e), 600)} />
                            <p className="text-sm font-semibold mb-1.5">Heading</p>
                            <input type="text" className="form-control mb-2 w-full" placeholder="" id={'heading'} defaultValue={data?.heading} maxLength={255} onChange={_debounce((e) => onHeadingUpdate(e), 700)} />
                            <p className="text-sm font-semibold mb-1.5">Sub Heading</p>
                            <input type="text" className="form-control mb-2 w-full" placeholder="" id={'sub-heading'} defaultValue={data?.subHeading} maxLength={255} onChange={_debounce((e) => onSubHeadingUpdate(e), 1000)} />
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

export default ProfileBlock